module.exports = __webpack_public_path__ + "static/media/icon-linkedin.3ab2a010.svg";